
<div class="dtf-olp" style="background-color: #E6E6E6;">

  <div class="container_dashboard">
    <div class="dtf-dashboard" style="padding-top: 41px; padding-bottom: 0px;">
      
      <div class="example-button-row">
        <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [value]="selectedState" (change)="onChangeButton($event)">
          <mat-button-toggle  [value]="toggleEnum.Option7" [class.selected]="selectedState === toggleEnum.Option7">Make a Payment</mat-button-toggle>
          <mat-button-toggle  [value]="toggleEnum.Option1" [class.selected]="selectedState === toggleEnum.Option1" style="background-color: #00566A !important; color: white !important;">Principal Payment</mat-button-toggle>
          <mat-button-toggle  [value]="toggleEnum.Option3" [class.selected]="selectedState === toggleEnum.Option3">Statement Payment</mat-button-toggle>
          <mat-button-toggle  [value]="toggleEnum.Option6" [class.selected]="selectedState === toggleEnum.Option6">Recurring Payment</mat-button-toggle>
          <mat-button-toggle  [value]="toggleEnum.Option4" [class.selected]="selectedState === toggleEnum.Option4">Manage Bank Profile</mat-button-toggle>
          <mat-button-toggle  [value]="toggleEnum.Option2" [class.selected]="selectedState === toggleEnum.Option2">Payment History</mat-button-toggle>
          <mat-button-toggle  [value]="toggleEnum.Option8" [class.selected]="selectedState === toggleEnum.Option8">Help</mat-button-toggle>
        </mat-button-toggle-group>
        </div>
    </div> 
  </div>

    <div class="container_dashboard">
      <div style=" padding-bottom: 21px;">
        <div class="cardlike">
          <h1>{{ 'onlinepayment.header1' | translate }}</h1>
        
          <br>
          <div style="font-size: large;">
            <p> You may have upcoming <a href="{{this.baseRedirect}}/home/scheduledpayment"><span
                  style="font-weight: bold; color: #00566A;">Scheduled Payments</span></a>. Click here to view the details and
              dates. &nbsp;
              <!-- <span>
                <button matIconButton aria-label="Example icon button with an open in new tab icon"
                  style="background: transparent; border: none; box-shadow: none;">
                  <a href="{{this.baseRedirect}}/home/scheduledpayment"><mat-icon
                      style="color: #00566A; height: 21px;">open_in_new</mat-icon></a>
                </button>
              </span> -->
            </p>
          </div>
        </div>
   
   
            <div class="container_dashboard"> 
            <!--Spinner on Login Load-->
            <div *ngIf="(!this.tableLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
                <div class="demo-container">
                    <span>{{ 'Invoice.Loading' | translate }}</span>
                    <div class="progress-bar">
                        <div class="progress-bar-value"></div>
                    </div>
                </div>
                <br>
            </div>
             <!-- Filters and table for principalPayment Step 1-->
             <div *ngIf="principalpaymentstep1">
                  <div
                      style="margin-right: 26px; padding-bottom: 15px; padding-left: 11px; ">
                      <div *ngIf="principalpayment">
                        <div class="row" style="display: flex;">
                          <div class="col">
                            <div class="card" >
                              <h5 style="font-weight: bold;">Select Bank Account</h5>
                              <p>Step 1: Select your preferred payment profile</p>
                              <div class="row">
                                <div class="col-lg-7 col-md-7 col-sm-2 col-6">
                                  <mat-form-field class="dropdown" appearance="outline">
                                    <mat-label>{{ 'onlinepayment.select1' | translate }}<span style="color: red;">*</span></mat-label>
                                    <mat-select [(ngModel)]="selected" (ngModelChange)="onChange()">
                                      <mat-option *ngFor="let opt of dropDownList" [value]="opt.id">
                                        {{opt.selectionPr}}
                                      </mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col">
                            <div class="card" style="padding-bottom: 48px;">
                            <h5 style="font-weight: bold;">Search By Account Number:</h5>
                            <div class="row">
                              <div class="col">
                                <mat-form-field appearance="outline" style="width: 100%;">
                                  <mat-label>{{ 'onlinepayment.filter1label' | translate }}</mat-label>
                                  <input matInput maxlength="13" style="outline: none;" (keyup)="applyFilterAccPr($event.target.value)" #input type="number">
                                  <img matSuffix class="example-form-img"
                                    src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
                                </mat-form-field>
                              </div>
                  
                            </div>
                          </div>
                          </div>
                        </div>
                      </div> 
                      <br>
                      <div class="card">

                      <p>Step 2: Just fill in your payment amount and the date you want to make the payment.</p>

                      <div *ngIf="showWarning" style="color: black; font-size: 15px; font-family: Verdana, Geneva, Arial, Helvetica, sans-serif; margin-bottom: 1%;" class="warning-message">
                        {{ warningMessage }}
                      </div>

                      <div style="color: red; font-size: 15px; font-family: Verdana, Geneva, Arial, Helvetica, sans-serif; margin-bottom: 1%;" *ngIf="invalidPr">
                          Please correct the following information.
                           <ul style="list-style-type: disc;">
                              <li *ngIf="required" style="margin-left:30px;" class="paragrapSpace" >Please supply the required information. An * indicates a required field. </li>
                              <li *ngIf="selectone" style="margin-left:30px;" class="paragrapSpace">Please select at lease one account or less than 26 accounts.</li>
                              <li *ngIf="amount" style="margin-left:30px;" class="paragrapSpace" >The payment amount must be greater than zero and less than or equal to $2,000,000.00 </li> 
                          </ul> 
                      </div>
                      
                      <mat-table [dataSource]="PrincipalDatasource" multiTemplateDataRows class="mat-elevation-z8"
                          matSort>
                          <!--US/EN Table loading-->
                          <ng-container matColumnDef="{{column.name}}"
                              *ngFor="let column of initPrincipalPaymentColumns; last as isLast; first as isFirst;">
                             

                              <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef
                                  style=" justify-content: left;">

                                  <!-- <span *ngIf="isFirst" style="margin-left: -22px;">
                                      <mat-checkbox (click)="calculateTotalAmountPr()"  (change)="$event ? masterTogglePr() : null"
                                          [checked]="selectionPr.hasValue() && isAllSelectedPr()"
                                          [indeterminate]="selectionPr.hasValue() && !isAllSelectedPr()">
                                      </mat-checkbox>
                                  </span> -->
                                  <div *ngIf="column.dispFormat==''">
                                    <mat-checkbox [ngClass]="{'white-border': !isChecked}" [disabled]="selection >= 50" (click)="calculateTotalAmountPr()"  (change)="$event ? masterTogglePr() : null"
                                    [checked]="selectionPr.hasValue() && isAllSelectedPr()"
                                    [indeterminate]="selectionPr.hasValue() && !isAllSelectedPr()">
                                    </mat-checkbox>
                                  </div>
                                   <!-- Principal Amount -->
                                  <div *ngIf="column.dispFormat=='principalamount'">
                                      {{column.display}}
                                  </div>
                                  <!-- Payment Date -->
                                  <div *ngIf="column.dispFormat=='date'">
                                      {{column.display}} <br> <span style="font-size: small;">MM/DD/YYYY</span>
                                      <!-- <br>
                                      <div style="display: inline-flex;">
                                          <input
                                              style="outline: none; width: 70%; height: 20px; margin-top: 4%; margin-bottom: 5%;"
                                              (keyup)="applyFilterDate($event.target.value)" #input type="date">
                                          <mat-icon fontIcon="search">
                                          </mat-icon>
                                      </div> -->
                                  </div>
                                  <!-- Account Number -->
                                  <div *ngIf="column.dispFormat=='acct'">
                                     <div class="row">  {{column.display}}</div>
                                    
                                     <!-- <div class="row">
                                          <div style="display: inline-flex;">
                                              <input
                                              style="outline: none; width: 70%; margin-top: 2%; margin-bottom: 5%;  height: 20px;"
                                              (keyup)="applyFilterAccPr($event.target.value)" #input type="text">
                                              <mat-icon fontIcon="search">
                                              </mat-icon>
                                          </div>
                                     </div> -->
                                     
                                     
                                  </div>

                              </mat-header-cell>

                              <mat-cell *matCellDef="let element" style="justify-content: left;">
                                <span class="mobile-label">
                                  <div *ngIf="!isFrench && column.dispFormat !== ''"> {{column.display}} :</div>
                                  <div *ngIf="!isFrench && column.dispFormat==''"> {{column.display}} </div>
                                  <div *ngIf="isFrench"> {{column.displayFR}} :</div>
                                </span>
                                  <!-- Principal Amount -->
                                  <div *ngIf="column.dispFormat=='principalamount'">
                                      <mat-form-field appearance="outline" style="width: 70%; margin-top: 7%; height: 70px;  justify-content: center; margin-bottom: -5px;">
                                      $ <input matInput type="text" (keypress)="positiveNumberOnly($event)" maxlength="12" style="width:97px;" [(ngModel)]="element.principalAmount" id="principalamount" (keypress)="restrictToTwoDecimals($event, element[column.name])"  (focusout)="convertToDecimalPr(element)"  />
                                      </mat-form-field>
                                         <span *ngIf="selectionPr.isSelected(element) &&(['0.00'].includes(element.principalAmount)||element.principalAmount>2000000)" alt="" style="width: 5px;margin-left:5px;">
                                          <img src="static/assets/img/dtf-assets/images/redesign/required_box.gif" style="width: 5px;margin-left:5px;">
                                   </span>
                                  </div>
                                  <div *ngIf="column.dispFormat==''">
                                    <div class="class-test">
                                      <mat-checkbox (click)="$event.stopPropagation(); calculateTotalAmountPr();"
                                      (change)="$event ? selectionPr.toggle(element) : null"
                                      [checked]="selectionPr.isSelected(element)">
                                      </mat-checkbox>
                                    </div>
                                  </div>
                                  <!-- Account Number -->
                                  <div *ngIf="column.dispFormat=='acct'" [ngClass]="{'highlight-row': isHighlighted(element[column.name])}" [ngStyle]="isHighlighted(element[column.name]) ? {'color': 'black', 'font-weight': 'bold'} : {}">
                                      {{element[column.name]}}
                                  </div>
                                   <!-- Payment Date -->
                                  <div *ngIf="column.dispFormat=='date'">
                                      <mat-form-field appearance="outline" style="width: 63%; margin-top: 7%; height: 70px;  justify-content: center; margin-bottom: -5px;">
                                          <input matInput [min]="minDate" [max]="maxDate[element.agreementNumber]" [(ngModel)]="currentDate[element.agreementNumber]"
                                            [matDatepicker]="datepicker">
                                          <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                                          <mat-datepicker #datepicker>
                                            <mat-datepicker-actions>
                                              <button mat-button matDatepickerCancel>{{ 'LoginModal.Cancel' | translate }}</button>
                                              <button mat-raised-button color="primary" matDatepickerApply>{{ 'LoginModal.Apply' | translate
                                                }}</button>
                                            </mat-datepicker-actions>
                                          </mat-datepicker>
                                        </mat-form-field>   
                                  </div>

                              </mat-cell>
                          </ng-container>

                          <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                          <ng-container matColumnDef="PrincipalPaymentResponseList">
                              <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                                  [attr.colspan]="displayedPrinicpalPaymentColumns.length">
                              </mat-cell>
                          </ng-container>

                          <mat-header-row *matHeaderRowDef="displayedPrinicpalPaymentColumns"></mat-header-row>
                          <mat-row *matRowDef="let element; columns: displayedPrinicpalPaymentColumns;"
                              class="example-element-row"
                              [class.example-expanded-row]="PrincipalPaymentResponseList === element"
                              (click)="PrincipalPaymentResponseList = PrincipalPaymentResponseList === element ? null : element">
                          </mat-row>
                          <mat-row *matRowDef="let row; columns: ['PrincipalPaymentResponseList']"
                              class="example-detail-row"></mat-row>

                          <!-- Row shown when there is no matching data. -->
                          <tr class="mat-row" *matNoDataRow>
                              <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter

                              </td>
                              <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre
                              </td>
                          </tr>

                      </mat-table>
                      <mat-paginator [pageSizeOptions]="[5,10, 25, 100]"></mat-paginator>
                    </div>
                  </div>
                  <div class="total-amount-wrapper && tile" style="margin-right: 28px; margin-left: 23px;">
                    <div>
                      <mat-form-field appearance="outline" style="width: 100%;">
                        <mat-label>{{ 'onlinepayment.select2' | translate }}<span style="color: darkred;">*</span></mat-label>
                        <input matInput [value]="totalAmountPr | currency: USD:true:'1.2-2'" readonly />
                      </mat-form-field>
                    </div>
                  
                    <button type="submit" class="mbfs-button submit-button" (click)="onSubmitPr()">
                      {{ 'onlinepayment.submit' | translate }}
                    </button>
                  </div>
              </div>
              <!-- principalPayment Step 2 on click of Submit Payment-->
              <div *ngIf="principalpaymentstep2">
                <div class="card">
                <div style="display: flex;">
                  <div class="row">
                    <div class="col">
                      <mat-form-field appearance="outline" style="width: 110%;">
                        <mat-label>Selected Bank Profile<span style="color: red;">*</span></mat-label>
                         <input matInput  [value]="getSelectedBankName()" readonly/>                                          
                      </mat-form-field>
                    </div>
                    <div class="col">
                      <mat-form-field appearance="outline" style="width: 110%;">
                        <mat-label>{{ 'onlinepayment.select2' | translate }}<span style="color: red;">*</span></mat-label>
                         <input matInput  [value]="totalAmountPr | currency: USD:true:'1.2-2'" readonly/>                                          
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                  <mat-table [dataSource]="PrincipalDatasource" multiTemplateDataRows class="mat-elevation-z8" matSort>
                      <!--US/EN Table loading-->
                      <ng-container matColumnDef="{{column.name}}"
                        *ngFor="let column of initPrincipalPaymentColumnsStep2; last as isLast; first as isFirst;">
                        <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef style="justify-content: center;">
                          <div> {{column.display}}</div>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" style="justify-content: center;">
                          <span class="mobile-label">
                            <div> {{column.display}} :</div>
                          </span>
                          <div *ngIf="column.dispFormat=='principalamount'"> 
                             {{element[column.name] | currency:'USD':true:'1.2-2'}}
                          </div>
                          <div *ngIf="column.dispFormat=='acct'"> 
                            {{element[column.name]}}
                          </div>
                          <div *ngIf="column.dispFormat=='date'"> 
                            {{element[column.name]  | date:'MM/dd/yyyy'}}
                          </div>
                          
                        </mat-cell>
                      </ng-container>
        
                      <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                      <ng-container matColumnDef="selectedPrincipalResponseList">
                        <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                          [attr.colspan]="displayedPrinicpalPaymentColumnsStep2.length">
                        </mat-cell>
                      </ng-container>
        
                      <mat-header-row *matHeaderRowDef="displayedPrinicpalPaymentColumnsStep2"></mat-header-row>
                      <mat-row *matRowDef="let element; columns: displayedPrinicpalPaymentColumnsStep2;" class="example-element-row"
                        [class.example-expanded-row]="selectedPrincipalResponseList === element"
                        (click)="selectedPrincipalResponseList = selectedPrincipalResponseList === element ? null : element">
                      </mat-row>
                      <mat-row *matRowDef="let row; columns: ['selectedPrincipalResponseList']" class="example-detail-row"></mat-row>
        
                      <!-- Row shown when there is no matching data. -->
                      <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter "{{input.value}}"</td>
                        <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre
                          "{{input.value}}"</td>
                      </tr>
        
                    </mat-table>
                    <br>
                  </div>
                    <br>
                    <p style="margin-left: 10px; font-weight: bold;"> Please review the following Authorization Statement before submitting your payment for processing.</p>
                    <br>
                    <div class="card">
                  <p style="padding: 10px; text-align:justify ;">
                    {{ 'onlinepayment.auth' | translate }}
                  <br><br>
                   <span style="font-weight: bold;">Notice:</span> The entry of a future dated payment transaction shall not be deemed or construed as acceptance by DTFS of a promise to pay in the future, a deferred payment offer or an amendment to the payment due dates in my lease, retail installment contract or promissory note and security agreement.	
                  </p>
                </div>
                  <br>
                  <mat-checkbox class="example-margin" [(ngModel)]="isChecked">
                    <label style="margin: 0px;">I have read and accept the terms of the above Authorization Statement.</label>   
                  </mat-checkbox> 
                  <br>
                  <br>
                  <div style="display:flex;flex-direction: row;gap:10px" >
                  <div *ngIf="agentview ==='true'">
                     <button class="mbfs-button" disabled>Authorize</button>
                  </div>
                   <div *ngIf="agentview !='true'">
                     <button class="mbfs-button" [disabled]="!isChecked || !this.tableLoaded" (click)="PrincipalPaymentAuthorize()">Authorize</button>
                   </div>
                 
                  <button class="mbfs-button" (click)="back2step1Pr()">Cancel</button>
                  </div>
              </div>
              <!-- principalPayment Step 3 on click of Authorize-->
              <div *ngIf="principalpaymentstep3">
                <div class="card">
                   <p style="font-weight: bold;"> Thank you for using the Online Payment Service. Please click "Print" to print your authorization(s) and retain them for your records.</p>
                   <div style="display: flex;">
                    <div class="row">
                      <div class="col">
                        <mat-form-field appearance="outline" style="width: 110%;">
                          <mat-label>Selected Bank Profile<span style="color: red;">*</span></mat-label>
                           <input matInput  [value]="getSelectedBankName()" readonly/>                                          
                        </mat-form-field>
                      </div>
                      <div class="col">
                        <mat-form-field appearance="outline" style="width: 110%;">
                          <mat-label>{{ 'onlinepayment.select2' | translate }}<span style="color: red;">*</span></mat-label>
                           <input matInput  [value]="totalAmountPr | currency: USD:true:'1.2-2'" readonly/>                                          
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="failureError" style="color: red;
                                            font-size: 15px;
                                            font-family: Verdana, Geneva, Arial, Helvetica, sans-serif; margin-bottom: 1%;">
                    We are currently experiencing technical difficulties, Please try again later.
                  </div>
                  <br>
                <mat-table [dataSource]="paymentdataSource" multiTemplateDataRows class="mat-elevation-z8" matSort style="pointer-events: none;">
                  <!--US/EN Table loading-->
                  <ng-container matColumnDef="{{column.name}}" *ngFor="let column of initColumns; last as isLast; first as isFirst;">
                    <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef style="justify-content: center; pointer-events: none;">
                      <div> {{column.display}}</div>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" style="justify-content: center; pointer-events: none;">
                      <span class="mobile-label">
                        <div> {{column.display}} :</div>
                      </span>
                      <div *ngIf="column.dispFormat=='currentamountdue'"> <!--Formats Contract String Columns-->
                        {{element[column.name] | currency:'USD':true:'1.2-2'}}
                      </div>
                      <div *ngIf="column.dispFormat=='acct'"> <!--Formats Contract String Columns-->
                        {{element[column.name]}}
                      </div>
                      <div *ngIf="column.dispFormat=='transaction'" style="color: blue;"> <!--Formats String Columns-->
                        {{element[column.name]}}
                      </div>
                      <div *ngIf="column.dispFormat=='status'"> <!--Formats String Columns-->
                        {{element[column.name]}}
                      </div>
                      <div *ngIf="column.dispFormat=='date1'"> <!--Formats date Columns-->
                        {{element[column.name] | date:'MM/dd/yyyy'}}
                      </div>
                    </mat-cell>
                  </ng-container>
                
                  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                  <ng-container matColumnDef="paymentPostedList">
                    <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                      [attr.colspan]="displayedColumns.length">
                    </mat-cell>
                  </ng-container>
                
                  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                  <mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"
                    [class.example-expanded-row]="paymentPostedList === element"
                    (click)="paymentPostedList = paymentPostedList === element ? null : element">
                  </mat-row>
                  <mat-row *matRowDef="let row; columns: ['paymentPostedList']" class="example-detail-row"></mat-row>
                
                  <!-- Row shown when there is no matching data. -->
                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter </td>
                    <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre
                    </td>
                  </tr>
                
                </mat-table>
                  <br>
                </div>
                  <br>
                  <button class="mbfs-button" (click)="DownloadPdfPr()">Print</button>
                  <button class="mbfs-button" (click)="BacktoDashBoard()">Done</button>
              </div>

            </div>
        </div>
    </div>
</div>


